/* My Doll Hair - selector de tonos por categoria.
   Al abrir un producto (o su vista rapida) se ven todos los tonos. Si el
   cliente filtra por una categoria y luego elige un tono, el bloque se vuelve
   a renderizar: el filtro se guarda como atributo data-tone-filter en el
   elemento que sobrevive al re-render (<quick-buy-modal> en la vista rapida,
   <product-rerender> en la pagina de producto), asi el CSS ya filtra en el
   primer pintado y no hay parpadeo.
   El atributo se borra al abrir el modal (show), para que cada apertura
   empiece siempre en "Todos los tonos". */
(function () {
  function catOf(input) {
    var m = /^tab-([a-z]+)-/.exec(input.id || '');
    return m ? m[1] : null;
  }

  function hostOf(el) {
    if (!el || !el.closest) return null;
    return el.closest('quick-buy-modal') || el.closest('product-rerender');
  }

  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;
      if (!input || !input.classList || !input.classList.contains('tone-tab-input')) return;
      // Solo el radio que queda marcado define el filtro: ignora eventos sueltos
      // sobre pestanas no marcadas.
      if (!input.checked) return;
      var host = hostOf(input);
      var cat = catOf(input);
      if (!host || !cat) return;
      host.setAttribute('data-tone-filter', cat);
    },
    true
  );

  // Mantiene el radio en sincronia con el filtro guardado (accesibilidad y teclado).
  function syncIn(node) {
    var wraps;
    if (node.matches && node.matches('[data-tone-tabs]')) {
      wraps = [node];
    } else if (node.querySelectorAll) {
      wraps = node.querySelectorAll('[data-tone-tabs]');
    } else {
      return;
    }

    for (var i = 0; i < wraps.length; i++) {
      var wrap = wraps[i];
      var host = hostOf(wrap);
      if (!host) continue;
      var cat = host.getAttribute && host.getAttribute('data-tone-filter');
      if (!cat) continue;
      var input = wrap.querySelector('.tone-tab-input[id^="tab-' + cat + '-"]');
      if (input && !input.checked) input.checked = true;
    }
  }

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1) syncIn(added[j]);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('quick-buy-modal').then(function () {
      var ctor = customElements.get('quick-buy-modal');
      if (!ctor || typeof ctor.prototype.show !== 'function') return;
      var original = ctor.prototype.show;
      ctor.prototype.show = function () {
        this.removeAttribute('data-tone-filter');
        return original.apply(this, arguments);
      };
    });
  }
})();
